import { render, staticRenderFns } from "./sub-location.vue?vue&type=template&id=9b7e2140&scoped=true&"
import script from "./sub-location.vue?vue&type=script&lang=js&"
export * from "./sub-location.vue?vue&type=script&lang=js&"
import style0 from "./sub-location.vue?vue&type=style&index=0&id=9b7e2140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7e2140",
  null
  
)

export default component.exports